import { Link, useLocation } from 'react-router';

import { onlineCourseResumePath } from 'my-core/routes';
import { getUserFirstName } from 'my-core/user-utils';

import Label from 'my-elements/Label';

import OnlineCoursePurchaseBundlePromo from './OnlineCoursePurchaseBundlePromo';

import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

const contentCss = ({ breakpoints, spacing }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(3),

  '.OCPFC-flex': { display: 'flex' },
  '.OCPFC-courseLabel': {
    display: 'flex',
    alignItems: 'center',
    marginLeft: spacing(1),
    marginBottom: spacing(-3.5),
    '& > h6': { marginRight: spacing(1) },
  },

  [breakpoints.only('xs')]: {
    '.OCPFC-flex': { flexDirection: 'column' },
    '.OCPFC-courseLabel': { margin: spacing(1, 0, 0, 0.5) },
  },
});

export default function OnlineCoursePurchaseFormConfirmation(props) {
  const { course, currentUser, header, onClose, onlineCourse } = props;
  const courseCode = course?.code || onlineCourse.course_code;
  const location = useLocation();
  const ocPath = onlineCourseResumePath(onlineCourse);
  const isInCourse = location.pathname.startsWith(ocPath);

  const isPublished = onlineCourse.status === 'published';

  return (
    <>
      <DialogContent>
        {header}
        <div css={contentCss}>
          <div className="OCPFC-flex">
            <div>
              <Typography variant="h6">{`Congrats, ${getUserFirstName(currentUser) || 'Scholar'}!`}</Typography>
              <Typography
                sx={{
                  color: 'text.secondary',
                }}
              >
                You&apos;ve successfully enrolled in:
              </Typography>
            </div>
            <div className="OCPFC-courseLabel">
              <Typography variant="h6">{courseCode}</Typography>
              {onlineCourse.assessment_name && <Label color="secondary" label={onlineCourse.assessment_name} />}
            </div>
          </div>
          {currentUser.pending_discount_codes?.[0] && (
            <OnlineCoursePurchaseBundlePromo promo={currentUser.pending_discount_codes[0]} />
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant={isPublished ? 'outlined' : 'contained'}>
          Close
        </Button>
        <Button
          component={isInCourse ? undefined : Link}
          nativeButton={isInCourse ? undefined : false}
          onClick={onClose}
          to={isInCourse ? undefined : ocPath}
          variant="contained"
        >
          {isInCourse ? 'Close' : 'Start Now'}
        </Button>
      </DialogActions>
    </>
  );
}
